<app-nav></app-nav>

<!-- ── TOASTS ── -->
@if (successMessage) {
  <div class="toast toast-success" role="status" aria-live="polite">
    <span class="toast__icon">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="20 6 9 17 4 12"/>
      </svg>
    </span>
    {{ successMessage }}
  </div>
}

@if (errorMessage) {
  <div class="toast toast-error" role="alert" aria-live="assertive">
    <span class="toast__icon">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
      </svg>
    </span>
    {{ errorMessage }}
  </div>
}

<!-- ══ WRAPPER ══ -->
<div class="rg__page" role="main" aria-label="Registro">

  <!-- ══ HERO ══ -->
  <section class="rg__hero" aria-hidden="true">

    <div class="rg__heroBg">
      <div class="rg__heroBgCircle rg__heroBgCircle--1"></div>
      <div class="rg__heroBgCircle rg__heroBgCircle--2"></div>
    </div>
    <div class="rg__heroAccent"></div>

    <div class="rg__heroContent">

      <div class="rg__heroLogo">
        <img
          src="https://res.cloudinary.com/dtyvd3fim/image/upload/v1764678577/ChatGPT_Image_12_nov_2025_17_33_14_1_hj26hs.png"
          alt="TripGO logo"
        />
      </div>

      <div class="rg__heroText">
        <h1 class="rg__heroTitle">TripGO</h1>
        <p class="rg__heroSub">{{'AUTH.REGISTER.HERO_SUB' | translate}}</p>
      </div>

      <div class="rg__heroPills">
        <span class="rg__heroPill">
          <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/></svg>
          {{ 'AUTH.HERO_PILLS.TOWNS' | translate }}
        </span>
        <span class="rg__heroPill">
          <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2l2.4 7.4H22l-6.2 4.5 2.4 7.4L12 17l-6.2 4.3 2.4-7.4L2 9.4h7.6z"/></svg>
          {{ 'AUTH.HERO_PILLS.PLACES' | translate }}
        </span>
        <span class="rg__heroPill">
          <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l8.84 8.84 8.84-8.84a5.5 5.5 0 0 0 0-7.78z"/></svg>
          {{ 'AUTH.HERO_STATS.FREE' | translate }}
        </span>
      </div>

      <!-- Stepper de pasos -->
      <div class="rg__heroSteps">
        <div class="rg__heroStep rg__heroStep--active">
          <div class="rg__stepNum">1</div>
          <div class="rg__stepTxt">{{ 'AUTH.REGISTER.STEPS.STEP1' | translate }}</div>
        </div>
        <div class="rg__stepConnector"></div>
        <div class="rg__heroStep">
          <div class="rg__stepNum rg__stepNum--pending">2</div>
          <div class="rg__stepTxt">{{ 'AUTH.REGISTER.STEPS.STEP2' | translate }}</div>
        </div>
        <div class="rg__stepConnector"></div>
        <div class="rg__heroStep">
          <div class="rg__stepNum rg__stepNum--pending">3</div>
          <div class="rg__stepTxt">{{ 'AUTH.REGISTER.STEPS.STEP3' | translate }}</div>
        </div>
      </div>

    </div>
  </section>

  <!-- ══ FORMULARIO ══ -->
  <aside class="rg__form">
    <div class="rg__formCard">

      <div class="rg__formHeader">
        <div class="rg__badgeNew">
          <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2l2.4 7.4H22l-6.2 4.5 2.4 7.4L12 17l-6.2 4.3 2.4-7.4L2 9.4h7.6z"/></svg>
          {{ 'AUTH.REGISTER.FORM.BADGE' | translate }}
        </div>
        <h2 class="rg__formTitle">{{ 'AUTH.REGISTER.FORM.TITLE' | translate }}</h2>
        <p class="rg__formSub">{{ 'AUTH.REGISTER.FORM.SUB' | translate }}</p>
      </div>

      <form #registerForm="ngForm" (ngSubmit)="onSubmit(registerForm)" novalidate class="rg__formFields">

        <!-- Nombre -->
        <div class="rg__field"
          [class.rg__field--valid]="nameCtrl.valid && nameCtrl.touched"
          [class.rg__field--error]="nameCtrl.invalid && nameCtrl.touched">
          <label class="rg__label" for="name">{{ 'AUTH.REGISTER.FORM.NAME_LABEL' | translate }}</label>
          <div class="rg__inputWrap">
            <span class="rg__inputIcon">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>
              </svg>
            </span>
            <input
              id="name"
              class="rg__input"
              [(ngModel)]="name"
              name="name"
              type="text"
              [placeholder]="'AUTH.REGISTER.FORM.NAME_PLACEHOLDER' | translate"
              required
              minlength="2"
              #nameCtrl="ngModel"
            />
            <span class="rg__inputStatus">
              <svg class="rg__statusOk" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#22c55e" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
              <svg class="rg__statusErr" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#ef4444" stroke-width="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </span>
          </div>
          <span class="rg__fieldMsg rg__fieldMsg--err"
            *ngIf="nameCtrl.invalid && (nameCtrl.touched || registerForm.submitted)">
            Mínimo 2 caracteres
          </span>
          <span class="rg__fieldMsg rg__fieldMsg--ok"
            *ngIf="nameCtrl.valid && nameCtrl.touched">
            {{ 'AUTH.REGISTER.FORM.NAME_VALID' | translate }}
          </span>
        </div>

        <!-- Email -->
        <div class="rg__field"
          [class.rg__field--valid]="emailCtrl.valid && emailCtrl.touched"
          [class.rg__field--error]="emailCtrl.invalid && emailCtrl.touched">
          <label class="rg__label" for="email">{{ 'AUTH.REGISTER.FORM.EMAIL_LABEL' | translate }}</label>
          <div class="rg__inputWrap">
            <span class="rg__inputIcon">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/>
              </svg>
            </span>
            <input
              id="email"
              class="rg__input"
              [(ngModel)]="email"
              name="email"
              type="email"
              [placeholder]="'AUTH.REGISTER.FORM.EMAIL_PLACEHOLDER' | translate"
              required
              email
              #emailCtrl="ngModel"
            />
            <span class="rg__inputStatus">
              <svg class="rg__statusOk" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#22c55e" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
              <svg class="rg__statusErr" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#ef4444" stroke-width="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </span>
          </div>
          <span class="rg__fieldMsg rg__fieldMsg--err"
            *ngIf="emailCtrl.invalid && (emailCtrl.touched || registerForm.submitted)">
            {{ 'AUTH.EMAIL_ERROR' | translate }}
          </span>
          <span class="rg__fieldMsg rg__fieldMsg--ok"
            *ngIf="emailCtrl.valid && emailCtrl.touched">
            {{'AUTH.EMAIL_CORRECT' | translate }}
          </span>
        </div>

        <!-- Contraseña -->
        <div class="rg__field"
          [class.rg__field--valid]="passwordCtrl.valid && passwordCtrl.touched"
          [class.rg__field--error]="passwordCtrl.invalid && passwordCtrl.touched">
          <label class="rg__label" for="password">{{ 'AUTH.PASSWORD' | translate }}</label>
          <div class="rg__inputWrap">
            <span class="rg__inputIcon">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>
              </svg>
            </span>
            <input
              id="password"
              class="rg__input"
              [(ngModel)]="password"
              name="password"
              [type]="showPassword ? 'text' : 'password'"
              [placeholder]="'AUTH.REGISTER.FORM.PASSWORD_LABEL' | translate"
              required
              minlength="8"X
              pattern="(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}"
              #passwordCtrl="ngModel"
              autocomplete="new-password"
            />
            <button
              type="button"
              class="rg__togglePass"
              (click)="togglePassword()"
              [attr.aria-label]="showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'"
            >
              <svg *ngIf="!showPassword" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
              <svg *ngIf="showPassword" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
            </button>
          </div>

          <!-- Barra de fortaleza -->
          <div class="rg__strength" *ngIf="password.length > 0">
            <div class="rg__strengthBar"
              [class.rg__strengthBar--weak]="password.length >= 1"
              [class.rg__strengthBar--ok]="password.length >= 6"
              [class.rg__strengthBar--strong]="passwordRegex.test(password)">
            </div>
            <div class="rg__strengthBar"
              [class.rg__strengthBar--ok]="password.length >= 6"
              [class.rg__strengthBar--strong]="passwordRegex.test(password)">
            </div>
            <div class="rg__strengthBar"
              [class.rg__strengthBar--strong]="passwordRegex.test(password)">
            </div>
            <div class="rg__strengthBar"
              [class.rg__strengthBar--strong]="passwordRegex.test(password) && password.length >= 12">
            </div>
            <span class="rg__strengthLbl">
              {{ password.length < 6 ? 'Débil' : !passwordRegex.test(password) ? 'Regular' : password.length >= 12 ? 'AUTH.REGISTER.FORM.PASSWORD_STRENGTH.VERY_STRONG' : 'Segura' }}
            </span>
          </div>

          <span class="rg__fieldMsg rg__fieldMsg--err"
            *ngIf="passwordCtrl.invalid && (passwordCtrl.touched || registerForm.submitted)">
            {{ 'AUTH.PASSWORD_ERROR' | translate }}
          </span>
          <span class="rg__fieldMsg rg__fieldMsg--ok"
            *ngIf="passwordCtrl.valid && passwordCtrl.touched">
            {{ 'AUTH.REGISTER.FORM.PASSWORD_VALID' | translate }}
          </span>
        </div>

        <!-- Confirmar contraseña -->
        <div class="rg__field"
          [class.rg__field--valid]="confirmPasswordCtrl.valid && confirmPasswordCtrl.touched && password === confirmPassword"
          [class.rg__field--error]="(confirmPasswordCtrl.invalid && confirmPasswordCtrl.touched) || (confirmPasswordCtrl.touched && password !== confirmPassword && confirmPassword.length > 0)">
          <label class="rg__label" for="confirmPassword">{{ 'AUTH.REGISTER.FORM.CONFIRM_PASSWORD_LABEL' | translate }}</label>
          <div class="rg__inputWrap">
            <span class="rg__inputIcon">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>
              </svg>
            </span>
            <input
              id="confirmPassword"
              class="rg__input"
              [(ngModel)]="confirmPassword"
              name="confirmPassword"
              [type]="showConfirmPassword ? 'text' : 'password'"
              [placeholder]="'AUTH.REGISTER.FORM.CONFIRM_PASSWORD_PLACEHOLDER' | translate"
              required
              minlength="8"
              autocomplete="new-password"
              #confirmPasswordCtrl="ngModel"
            />
            <button
              type="button"
              class="rg__togglePass"
              (click)="toggleConfirmPassword()"
              [attr.aria-label]="showConfirmPassword ? 'Ocultar' : 'Mostrar'"
            >
              <svg *ngIf="!showConfirmPassword" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
              <svg *ngIf="showConfirmPassword" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
            </button>
          </div>

          <span class="rg__fieldMsg rg__fieldMsg--err"
            *ngIf="confirmPasswordCtrl.invalid && (confirmPasswordCtrl.touched || registerForm.submitted)">
            {{ 'AUTH.REGISTER.FORM.CONFIRM_PASSWORD_LABEL' | translate }}
          </span>
          <span class="rg__fieldMsg rg__fieldMsg--err"
            *ngIf="
              (passwordCtrl.touched || confirmPasswordCtrl.touched || registerForm.submitted) &&
              password && confirmPassword && password !== confirmPassword
            ">
            {{ 'AUTH.REGISTER.FORM.CONFIRM_PASSWORD_ERROR' | translate }}
          </span>
          <span class="rg__fieldMsg rg__fieldMsg--ok"
            *ngIf="confirmPasswordCtrl.valid && confirmPasswordCtrl.touched && password === confirmPassword && confirmPassword.length > 0">
            {{ 'AUTH.REGISTER.FORM.CONFIRM_PASSWORD_VALID' | translate }}
          </span>
        </div>

        <div class="rg__divider"></div>

        <!-- Botón -->
        <button
          class="rg__btnPrimary"
          type="submit"
          [disabled]="registerForm.invalid"
        >
          <span class="rg__btnLabel">{{ 'AUTH.REGISTER.FORM.BUTTON' | translate }}</span>
          
        </button>

        <!-- Ya tienes cuenta -->
        <div class="rg__divider"></div>

        <a routerLink="/login" class="rg__btnSecondary">
          {{ 'AUTH.REGISTER.FORM.HAVE_ACCOUNT' | translate }}
        </a>

      </form>

      <p class="rg__formFooter">
        {{ 'AUTH.REGISTER.FORM.TERMS_TEXT' | translate }}
        <a href="#" class="rg__footerLink">{{ 'AUTH.REGISTER.FORM.TERMS' | translate }}</a> y
        <a href="#" class="rg__footerLink">{{ 'AUTH.REGISTER.FORM.PRIVACY' | translate }}</a>
      </p>

    </div>
  </aside>

</div>

<app-footer></app-footer>
